import { render, staticRenderFns } from "./PaymentInput.vue?vue&type=template&id=153146f1&scoped=true&"
import script from "./PaymentInput.vue?vue&type=script&lang=js&"
export * from "./PaymentInput.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInput.vue?vue&type=style&index=0&id=153146f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153146f1",
  null
  
)

export default component.exports